import { Monitor, Moon, Sun } from 'lucide-react';
import type { Appearance, Me, ThemeChoice } from '@kaba/shared';
import { api } from '../lib/api';
import { queryClient } from '../lib/board';
import { setThemeChoice } from '../lib/theme';
import { toast } from '../lib/toast';
import { cx } from './ui/ui';

const OPTIONS: { v: ThemeChoice; label: string; icon: typeof Sun }[] = [
  { v: 'system', label: 'Wie das Gerät', icon: Monitor },
  { v: 'light', label: 'Hell', icon: Sun },
  { v: 'dark', label: 'Dunkel', icon: Moon },
];

/** Persönliche Darstellung: ändert nur die eigene Ansicht, nie das gemeinsame Erscheinungsbild (B01) */
export function AppearanceSection({ me }: { me: Me }) {
  const save = async (a: Appearance) => {
    setThemeChoice(a.theme);
    // Laufendes Nachladen (z. B. nach dem Start mit Stand vom Gerät) darf die Änderung nicht zurückdrehen
    void queryClient.cancelQueries({ queryKey: ['me'] });
    queryClient.setQueryData<Me>(['me'], (m) => (m ? { ...m, appearance: a } : m));
    try {
      await api.put('/api/me/appearance', a);
    } catch (e) {
      toast.error((e as Error).message);
    }
  };
  return (
    <section className="flex flex-col gap-3" aria-labelledby="appearance-h">
      <h2 id="appearance-h" className="text-lg font-semibold">
        Darstellung
      </h2>
      <div role="radiogroup" aria-labelledby="appearance-h" className="grid grid-cols-3 gap-2">
        {OPTIONS.map(({ v, label, icon: Icon }) => (
          <label
            key={v}
            className={cx(
              'flex min-h-16 cursor-pointer flex-col items-center justify-center gap-1 rounded-xl border px-2 text-sm font-medium has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-[var(--color-accent-fg)]',
              me.appearance.theme === v ? 'border-accent bg-accent-soft' : 'border-[var(--line)]',
            )}
          >
            <input type="radio" name="theme" className="sr-only" checked={me.appearance.theme === v} onChange={() => void save({ ...me.appearance, theme: v })} />
            <Icon size={18} aria-hidden />
            {label}
          </label>
        ))}
      </div>
      <label className="flex min-h-11 items-start gap-3 text-sm">
        <input type="checkbox" className="mt-0.5 size-5 accent-[var(--color-accent)]" checked={me.appearance.hideDecor} onChange={(e) => void save({ ...me.appearance, hideDecor: e.target.checked })} />
        <span>
          Hintergrundbilder von Boards ausblenden
          <span className="block text-xs text-[var(--ink-soft)]">Statt des Bildes erscheint eine ruhige Farbe. Logo und Markenfarbe bleiben.</span>
        </span>
      </label>
      <p className="text-xs text-[var(--ink-soft)]">Gilt nur für dich, auf allen deinen Geräten. Logo und Markenfarbe eines Boards bleiben erhalten.</p>
    </section>
  );
}
